import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CheckSvg from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Header from 'layout/atoms/Header/Header';
import Loader from 'layout/atoms/Loader/Loader';
import Modal from 'layout/atoms/Modal/Modal';
import TableGrid, { Body, Cell, Head, Row } from 'layout/atoms/TableGrid/TableGrid';
import { closeModal } from 'store/layoutSlice';
import { selectSpecificationCostsAverageDetails, selectSpecificationCostsStatus, } from 'store/specificationCostsSlice';
import downloadFile from 'utils/downloadUtils';
function EstimatedCostsAverage() {
    var _a;
    const { t, i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    // const modelSpecificationId = useSelector((state) => state.specificationDetails.item.id);
    const estimatedCostDetailsData = useSelector(selectSpecificationCostsAverageDetails);
    const fetchStatus = useSelector(selectSpecificationCostsStatus).fetchCostAverage;
    const isLoading = fetchStatus === 'loading' || fetchStatus === 'idle';
    const [exporting, setExporting] = useState(false);
    const onClickExport = useCallback(() => {
        setExporting(true);
        downloadFile(`/export/getSpecificationAverageCosts/${estimatedCostDetailsData.id}/${i18n.language}`).finally(() => setExporting(false));
    }, [i18n.language, estimatedCostDetailsData.id]);
    return (React.createElement(Modal, { name: "estimatedCostsAverage", size: "l", header: React.createElement(Header, { size: "m" }, t('specification_cost_details_modal.average.title')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'estimatedCostsAverage' })) }, t('common:close')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckSvg, null), onClick: onClickExport, loading: exporting, disabled: isLoading }, t('specification_cost_details_modal.average.export'))) }, isLoading ? (React.createElement(Loader, null)) : (React.createElement(TableGrid, { columns: [
            ['120px', '1fr'],
            ['100px', '1fr'],
            ['100px', '1fr'],
            ['80px', '1fr'],
            ['120px', '1fr'],
            ['120px', '1fr'],
        ] },
        React.createElement(Head, null,
            React.createElement(Row, { head: true },
                React.createElement(Cell, null, t('product')),
                React.createElement(Cell, null, t('variant')),
                React.createElement(Cell, null, t('specification_cost_details_modal.average.consumption')),
                React.createElement(Cell, null, t('common:unit')),
                React.createElement(Cell, null, t('specification_cost_details_modal.average.weighted_average_unit_price', {
                    currency: 'PLN',
                })),
                React.createElement(Cell, { align: "right" }, t('specification_cost_details_modal.average.average_cost_in_currency', {
                    currency: 'PLN',
                })))),
        React.createElement(Body, null, (_a = estimatedCostDetailsData === null || estimatedCostDetailsData === void 0 ? void 0 : estimatedCostDetailsData.componentVariantAverageCostSummaries) === null || _a === void 0 ? void 0 : _a.map((variant) => (React.createElement(Row, { key: variant.component.name },
            React.createElement(Cell, null, variant.component.name),
            React.createElement(Cell, null, variant.color),
            React.createElement(Cell, null, Number(variant.consumptionValue.toFixed(2))),
            React.createElement(Cell, null, variant.consumptionType.labelPL),
            React.createElement(Cell, null, Number(variant.unitCost.toFixed(2))),
            React.createElement(Cell, { align: "right" }, Number(variant.costInSpecificationCurrency.toFixed(2)))))))))));
}
export default memo(EstimatedCostsAverage);
